import { Link } from "react-router-dom";
import Seo, { breadcrumbLd } from "../lib/seo";
import { PRODUCTS } from "../data/content";
import { Breadcrumbs } from "../components/site/Layout";
import { PageHero, CtaBand } from "../components/site/Sections";
import { Reveal } from "../components/site/Reveal";

export default function Products({ variant }) {
  const isHolo = variant === "hologram";
  const isSecurity = variant === "security";
  const path = isHolo ? "/hologram-stickers" : isSecurity ? "/security-labels" : "/products";
  const title = isHolo
    ? "Custom Hologram Stickers in UAE | NanoMax Holo Solutions"
    : isSecurity
    ? "Security Labels in UAE | NanoMax Holo Solutions"
    : "Hologram Stickers & Security Labels in UAE | NanoMax";
  const desc = isHolo
    ? "Custom hologram stickers manufactured in the UAE — 3D, QR, tamper-evident and serialised holographic labels designed around your brand and security needs."
    : isSecurity
    ? "Security labels and anti-counterfeit solutions in the UAE, including tamper-evident, serialised and QR-verifiable holographic labels for brand protection."
    : "Explore hologram stickers and security labels manufactured in the UAE by NanoMax — 3D, QR, tamper-evident, serialised, UV and custom holographic labels.";
  const h1 = isHolo ? "Custom Hologram Stickers in UAE" : isSecurity ? "Security Labels in UAE" : "Hologram Stickers & Security Labels in UAE";

  return (
    <>
      <Seo title={title} description={desc} path={path} image={PRODUCTS[0].image}
        jsonLd={breadcrumbLd([{ name: "Home", path: "/" }, { name: "Products", path }])} />
      <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: h1 }]} />
      <PageHero overline="Products" title={h1}
        subtitle="A complete range of holographic security labels, each customizable around your product, packaging and authentication requirements." />
      <section className="px-6 md:px-10 lg:px-16 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.04}>
              <Link to={`/products/${p.slug}`} className="card grayscale-hover group block h-full overflow-hidden" data-testid={`product-card-${i}`}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={p.image} alt={p.alt} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="p-6">
                  <h2 className="font-head text-xl font-semibold group-hover:text-holo-cyan transition-colors">{p.name}</h2>
                  <p className="text-sm text-[#8A8A9B] mt-3 leading-relaxed">{p.tile}</p>
                  <span className="link-arrow mt-5 inline-flex">View {p.name} <span aria-hidden>&rarr;</span></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand sourcePage={path} />
    </>
  );
}
